// This mock file provides the data required by International.js for both the list and detail views.
const cruise = [
  {
    id: 1,
    title: "Bali Retreat",
    description: "7 Days 6 Nights of serene beaches and cultural immersion.",
    image: "",
    images: "",
    overview:
      "Experience the magic of Bali with its stunning rice paddies, ancient temples, and vibrant art scene. Perfect for relaxation and adventure.",
    duration: "7 Days / 6 Nights",
    itinerary: [
      {
        day: 1,
        title: "Arrival in Denpasar",
        details: [
          "Check into Seminyak, relaxing evening.",
          "Check into Seminyak, relaxing evening.",
        ],
      },

      {
        day: 2,
        title: "Ubud Culture Tour",
        details: "Visit Tegalalang Rice Terraces and Monkey Forest.",
      },
      {
        day: 3,
        title: "Beach Day",
        details: "Explore Kuta and Seminyak beaches.",
      },
      {
        day: 4,
        title: "Temple Visit",
        details: "Tour Uluwatu Temple at sunset.",
      },
      {
        day: 5,
        title: "Water Sports",
        details: "Snorkeling or diving near Nusa Dua.",
      },
      {
        day: 6,
        title: "Free Day / Shopping",
        details: "Explore local markets and enjoy a spa session.",
      },
      {
        day: 7,
        title: "Departure",
        details: "Transfer to Denpasar International Airport.",
      },
    ],
    inclusions: [
      "Accommodation in 4-star hotels",
      "Daily breakfast",
      "Airport transfers",
      "Guided tours as per itinerary",
      "All entrance fees",
    ],
    exclusions: [
      "International airfare",
      "Travel insurance",
      "Personal expenses",
      "Meals not mentioned in inclusions",
    ],

    whatsappNumber: "919876543210",
  },
];

export default cruise;
